export const commonMenus = [
    {
        label: '指导',
        key: 'Guide',
        children: [
            {
                label: '介绍',
                key: 'Introduction'
            },
            {
                label: '使用必看',
                key: 'GettingStarted'
            },
            {
                label: '更新日志',
                key: 'UpdateLog'
            },
            {
                label: '常见问题',
                key: 'faq'
            },
            // {
            //     label: '项目模版',
            //     key: 'ProjectTemplate'
            // }
        ],
    },
    {
        label: '图表文档',
        key: 'Documentation',
        children: [
            // {
            //     label: '公共配置',
            //     key: 'CommonConfig'
            // },
            {
                label: 'McLineChart（折线图）',
                key: 'McLineChart'
            },
            {
                label: 'McBarChart（柱状图）',
                key: 'McBarChart'
            },
            {
                label: 'McLineBarChart（折线与柱状组合图）',
                key: 'McLineBarChart'
            },
            {
                label: 'McHorBarChart（横向柱状图）',
                key: 'McHorBarChart'
            },
            {
                label: 'McPieChart（饼图）',
                key: 'McPieChart'
            },
            {
                label: 'McRadarChart（雷达图）',
                key: 'McRadarChart'
            },
            {
                label: 'McGaugeChart（仪表盘）',
                key: 'McGaugeChart'
            },
            // {
            //     label: 'McPointChart（散点图）',
            //     key: 'McPointChart'
            // }
        ]
    }
]
export const menus = [
    ...commonMenus,
    {
        label: '代码案例',
        key: 'SubMenu',
        children: [
            {
                type: 'group',
                label: '插件',
                children: [
                    {
                        label: '生态案例',
                        key: 'EcologicalCase'
                    },
                    // {
                    //     label: (
                    //         <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
                    //             推特
                    //         </a>
                    //     )
                    // },
                    // {
                    //     label: (
                    //         <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
                    //             码云
                    //         </a>
                    //     )
                    // },
                ]
            },
            {
                type: 'group',
                label: '社会',
                children: [
                    // {
                    //     label: 'github',
                    //     key: 'https://gitee.com/cyaofeng_admin/mc-charts'
                    // },
                    // {
                    //     label: (
                    //         <a href="https://ant.design" target="_blank" rel="noopener noreferrer">
                    //             推特
                    //         </a>
                    //     )
                    // },
                    {
                        label: (
                            <a href="https://gitee.com/cyaofeng_admin/mc-charts" target="_blank" rel="noopener noreferrer">
                                码云
                            </a>
                        )
                    },
                    {
                        label: 'OpenHarmony',
                        key: 'https://ohpm.openharmony.cn/#/cn/detail/@mcui%2Fmccharts'
                    }
                ]
            }
        ]
    }
];
